<template>
  <div id="about-content-modal" class="about-content">
    <div class="modal-content" :class="{'active': showContent}">
      <div class="container">
        <div class="justify-content-center row mb-2">
          <div class="col-12 col-md-9 col-lg-8 text-left">
            <span class="close-icon" @click="closeContent()">
              <IconClose :height="48" :width="48" />
            </span>
            <h3 class="mb-5 content_title"><IconInfo class="mr-2" :width="24" :height="24" /> {{ $t('about.title') }}</h3>
            <div class="content mb-5" v-html="$t('about.body')"></div>
          </div>
        </div>  
        
        <div class="justify-content-center row mb-5">
          <div class="col-12 col-md-9 col-lg-8 text-left">
            <h4 class="mb-3 content_title"><IconInfo class="mr-2" :width="24" :height="24" /> {{ $t('about.legal_title') }}</h4>
            <div class="content mb-5" v-html="$t('about.legal')"></div>
          </div>
        </div>  
        
        <div class="justify-content-center row mb-5">
          <div class="col-12 col-md-9 col-lg-8 text-left">
            <h4 class="mb-3 content_title"><IconInfo class="mr-2" :width="24" :height="24" />  {{ $t('credits.title') }}</h4>
            <div class="content" v-html="$t('credits.body')"></div>
          </div>
        </div>  

      </div>
    </div>
  </div>
</template>

<style lang="scss">

  .overlay-content {
    &.active {
      .modal-content {
        transition-delay: 2s;
        top: 0;
      }      
    }
  }

  .modal-content {
    position: fixed;
    left: 0;
    height: 100vh;
    width: 100vw;
    padding: 0 5px;
    padding-top: 10vh;
    z-index: 9999;
    background: #191919fc;
    overflow-y: auto;
    border-radius: 5px 0 0 5px;
    top: 200vh;
    transition: top .2s ease-in;
    transition-delay: 2s;

    &__container {
      max-width: 720px;
      margin: 0 auto;
    }

    ul {
      margin: 0;
      padding: 10px;
      list-style: none;
    }

    li {
      padding: 10px 0;
      border-bottom: dashed 1px #333;
    }

    a {
      padding: 0;
      color: #fff;
    }

    .content {
      font-size: 18px;
      color: #fff;
    }

    .content_title {
      font-size: 31px;
      color: #fff;
    }

    .close-icon {
      position: absolute;
      top: -55px;
      right: 0;
      text-align: right;
      padding: 10px;
      align-items: flex-end;
      text-align: right;
      
      cursor: pointer;
      z-index: 9999;

      a {
        display: inline;
      }

      svg {
        fill: #fff;
      }
    }
  }
</style>

<script>
  import IconClose from '@/components/IconClose'
  import IconInfo from '@/components/IconInfo'

  export default {
    name: 'AboutContent',
    components: {
      IconInfo,
      IconClose
    },
    props: {
      openContent: [Boolean, String]
    },
    data() {
      return {
        showContent: this.openContent
      }
    },
    methods: {
      closeContent() {
        document.querySelector('.overlay-content').classList.remove('active')

        setTimeout(() => {
          window.history.back()
        }, 100)
      }
    }
  }

</script>